import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { CeDropdown } from "../generic/components/form-fields/ce-dropdown";
import { multiformatAtom } from "../multiformat/store/multiformat-atom";

import type {
  ContentTypeOption,
  CreateContentRequest,
  Multiformat,
} from "../multiformat/store/types";
import type { FC } from "react";

export function sortTypes(
  multiformat: Multiformat,
  incudePrototypes: boolean,
): ContentTypeOption[] {
  const sorting = [
    "Communication",
    "Video",
    "Landscape Logo",
    "Square Logo",
    "TV Display",
    "Certificate",
    "Video Call Background",
    "Poster",
    "FAQ",
    "Manager One-Pager",
    "Horizontal Banner",
    "Guide",
  ];

  return multiformat.content_types
    .filter((contentType) => incudePrototypes || !contentType.prototype)
    .toSorted((a, b) => {
      const indexA = sorting.indexOf(a.name);
      const indexB = sorting.indexOf(b.name);

      const rankA = indexA === -1 ? Infinity : indexA;
      const rankB = indexB === -1 ? Infinity : indexB;

      if (rankA === rankB) {
        return a.name.localeCompare(b.name);
      }

      return rankA - rankB;
    })
    .map((c) => ({
      label: c.name,
      value: c.name,
    }));
}

export const ContentTypeSelect: FC<{ prototypes: boolean; loaded: boolean }> = ({
  prototypes,
  loaded,
}) => {
  const loader = useAtomValue(multiformatAtom);

  const sortedTypes = useMemo(() => {
    if (!loaded || loader.loading || !loader.data) return undefined;

    return sortTypes(loader.data, prototypes);
  }, [loaded, loader.loading, loader.data, prototypes]);

  return (
    <CeDropdown<CreateContentRequest>
      analyticsCategory="mfai"
      label="Format"
      name="format"
      loading={!sortedTypes}
      disabled={!sortedTypes}
      options={sortedTypes ?? []}
      disableClearable
      InputProps={{
        sx: {
          backgroundColor: "white",
          borderRadius: 2,
        },
      }}
    />
  );
};
